module.exports = __webpack_public_path__ + "img/竖向中线对齐3.44393039.svg";